import { useEffect } from 'react';
import history from '../history';
import { klaviyoActiveOnSite } from 'utils/klaviyo';

// Fires Klaviyo's "Active on Site" event on the initial render and on every
// client-side (SPA) route change.
//
// klaviyo.js tracks Active on Site itself when it loads, but React never reloads
// the page, so without this only the landing pageview is ever reported.
//
// Listens on the shared history object rather than useLocation() so this can sit
// alongside <Router /> in Main.js instead of inside it, matching PageLoadTracker.
// history.listen() does not fire for the first render, hence the call up front.
const KlaviyoPageTracker = () => {
    useEffect(() => {
        klaviyoActiveOnSite();

        const unlisten = history.listen(() => klaviyoActiveOnSite());
        return () => unlisten();
    }, []);

    return null;
};

export default KlaviyoPageTracker;
